import React from 'react'
import { Flex, Modal, Span, Button, styled, CheckBox } from '@fareye/ui'
import { IKeyValue } from '@fareye/types'
import { useTranslation } from '@fareye/common'
import {
  AddFiltersListingContainer,
  AddFilterListingApplicationButton,
  AddFilterListingApplicationButtonLabel,
  FilterCategoryListing
} from '../../style/styled'
import { getFilterCategoryListComponent } from './FilterCatgeoryListing'
import { inTransitConstant } from '../../config/constants'

export const AddFiltersListing = (props: any) => {
  const {
    showMoreFiltersModal,
    setShowMoreFiltersModal,
    selectedMoreFilter,
    setSelectedMoreFilter,
    moreFilterOptions,
    globalSearch
  } = props
  const { t } = useTranslation()
  const [checkedFilters, setCheckedFilters] = React.useState<
    IKeyValue<Array<string>>
  >(selectedMoreFilter.selectedFilters)
  React.useEffect(() => {
    setCheckedFilters(selectedMoreFilter.selectedFilters)
  }, [selectedMoreFilter.selectedFilters])

  const handleChange = (isChecked: boolean, key: string, value: string) => {
    if (isChecked) {
      // unselecting the filter
      setCheckedFilters((oldCheckedFilters: any) => {
        return {
          ...checkedFilters,
          [key]: oldCheckedFilters[key].filter(
            (selectedValue: string) => selectedValue !== value
          )
        }
      })
    } else {
      // selecting the filter
      if (!!checkedFilters[key]) {
        setCheckedFilters((oldCheckedFilters: any) => {
          return {
            ...checkedFilters,
            [key]: [...oldCheckedFilters[key], value]
          }
        })
      } else {
        setCheckedFilters((oldCheckedFilters: any) => {
          return {
            ...checkedFilters,
            [key]: [value]
          }
        })
      }
    }
  }
  return (
    <AddFiltersListingContainer
      toggleModal={showMoreFiltersModal}
      setToggleModal={(ev: boolean) => {
        setCheckedFilters(selectedMoreFilter.selectedFilters)
        setShowMoreFiltersModal(ev)
      }}
      variant="xs drawer Bottom-Right"
      style={{
        content: {
          background: '#f9fafb',
          maxHeight: 'calc(100vh - 50px)',
          height: 'calc(100vh - 50px)',
          width: '35vw',
          boxShadow: '0px -2px 4px rgba(134, 134, 134, 0.5)'
        }
      }}
    >
      <Flex
        column
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      >
        <Flex
          alignItemsFlexStart
          style={{
            width: '100%',
            background: '#FFFFFF',
            boxShadow:
              '0px 1.6px 3.6px rgba(47, 60, 69, 0.13), 0px 0.3px 0.9px rgba(0, 0, 0, 0.1)',
            flex: '0 0 auto'
          }}
        >
          <Span variant="h6" m={4}>
            {t(inTransitConstant['advancedFilters'])}
          </Span>
        </Flex>
        <Flex
          column
          justifyContentSpaceBetween
          style={{ width: '100%', flex: '1 1 auto', overflow: 'scroll' }}
        >
          <FilterCategoryListing>
            {Object.keys(moreFilterOptions).map((item: string) => {
              let prettyItem = moreFilterOptions[item]['prettyName']
              let filterOptions = moreFilterOptions[item]['aggregations']
              return (
                <Flex key={item} column m={4}>
                  {getFilterCategoryListComponent(
                    item,
                    prettyItem,
                    filterOptions,
                    checkedFilters,
                    setCheckedFilters,
                    handleChange,
                    t
                  )}
                </Flex>
              )
            })}
          </FilterCategoryListing>
        </Flex>
        <Flex
          justifyContentFlexEnd
          p={2}
          bg="#fff"
          style={{ width: '100%', flex: '0 0 auto' }}
        >
          <AddFilterListingApplicationButton
            style={{ border: '1px solid #1276D3' }}
            onClick={() => {
              setCheckedFilters({})
              setSelectedMoreFilter({ selectedFilters: {} })
            }}
          >
            <AddFilterListingApplicationButtonLabel
              variant="h6"
              style={{
                color: '#1276D3'
              }}
            >
              {t(inTransitConstant['reset'])}
            </AddFilterListingApplicationButtonLabel>
          </AddFilterListingApplicationButton>
          <AddFilterListingApplicationButton
            style={{
              background: '#1276D3'
            }}
            onClick={() => {
              setSelectedMoreFilter({ selectedFilters: checkedFilters })
              setShowMoreFiltersModal(false)
            }}
          >
            <AddFilterListingApplicationButtonLabel
              variant="h6"
              style={{
                color: '#FFFFFF'
              }}
            >
              {t(inTransitConstant['applyFilters'])}
            </AddFilterListingApplicationButtonLabel>
          </AddFilterListingApplicationButton>
        </Flex>
      </Flex>
    </AddFiltersListingContainer>
  )
}
